export default {"src":"/_next/static/media/ready-now.2ce33534.svg","height":26,"width":29,"blurWidth":0,"blurHeight":0};